import GetRootContent from './getter'
export { ROOT_ENTRY_ID } from './data'
export { GetRootContent }
